import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web/common/pete/TraceEventTracker';

export const eventKey = 'signup-verticalized_image_fetch-error';

/**
 * Record error when fetching verticalized image fails.
 */
export function trackSignupVerticalizedImageFetchError(): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
  });
}
